import React from 'react';

const Notfound = () => {
    return (
        <div>
            <h1 className="text-8xl">404 not Found</h1>
        </div>
    );
};

export default Notfound;